import { Button } from '../ui/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '../ui/card'

export function TestInstructions({ onStart, testType }) {
  return (
    <Card className="w-full bg-white dark:bg-slate-800">
      <CardHeader>
        <CardTitle className="text-2xl text-gray-900 dark:text-gray-50">
          {testType === 'initial' ? 'Initial Test' : 'Final Test'} Instructions
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-gray-700 dark:text-gray-200">
        <div className="space-y-2">
          <h3 className="font-semibold text-gray-800 dark:text-gray-100">Test Overview:</h3>
          <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 dark:text-gray-300">
            <li>This test contains multiple choice questions</li>
            <li>Each page contains 10 questions</li>
            <li>Total duration: 50 minutes</li>
            <li>You cannot go back to previous questions once submitted</li>
            <li>Ensure you have a stable internet connection</li>
          </ul>
        </div>

        <div className="space-y-2">
          <h3 className="font-semibold text-gray-800 dark:text-gray-100">Important Notes:</h3>
          <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 dark:text-gray-300">
            <li>Do not refresh the page during the test</li>
            <li>Answer all questions before proceeding to the next page</li>
            <li>You can review your answers before final submission</li>
          </ul>
        </div>
      </CardContent>
      <CardFooter className="dark:bg-transparent">
        <div className='w-full flex justify-end'>
        <Button 
         className="px-4 py-2 text-base bg-[#EFA938] text-white rounded-lg hover:bg-[#EFA938] dark:bg-[#b36f23] dark:hover:bg-[#b36f23]"
         onClick={onStart}>
          Start Test
        </Button>
        </div>
      </CardFooter>
    </Card>
  )
}
